import { $http } from '@/utils';

/**
 * @namespace Service
 * @class UserIdentity
 * @exports Service/Account/UserIdentity
 * @description API User Identity Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class UserIdentity {
	/**
	 * @static @name patch
	 * @description Update some User Identity for ID
	 * @param {String} id
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static patch(id, payload) {
		return $http.patch(`account/user/identity/${id}`, payload);
	}
}
